import { createFileRoute } from "@tanstack/react-router";
import { FinanceTransferModals } from "@/components/finance-transfer/finance-transfer-modals";
import FinanceTransferTable from "@/components/finance-transfer/finance-transfer-table";
import { Button } from "@/components/ui/button";
import { useTranslate } from "@/hooks/use-translate";
import useAppStore from "@/store";
import { Plus } from "lucide-react";

export const Route = createFileRoute("/(dasboard)/finance/transfers")({
  component: FinanceTransfersPage,
});

function FinanceTransfersPage() {
  const store = useAppStore();
  const { t } = useTranslate();
  return (
    <>
      <FinanceTransferModals />
      <div className="max-w-7xl mx-auto">
        <header className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold"> {t("Transfers")} </h2>
          <Button
            onClick={() => {
              store.display.show("create_finance_transfer");
            }}
          >
            <Plus className="w-4 h-4" />
            {t("Transfer fund")}
          </Button>
        </header>
        <FinanceTransferTable />
      </div>
    </>
  );
}
